type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: Props) {
  const center = align === 'center';
  return (
    <div className={center ? 'max-w-2xl mx-auto text-center' : 'max-w-2xl'}>
      <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide uppercase text-accent-700">
        <span className="w-6 h-px bg-accent-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">{title}</h2>
      {desc && <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}